/**
 * Scroll Animation Utility
 *
 * Adds scroll-triggered animations to DOM elements.
 * Elements will animate when they come into view while scrolling down.
 */
const DEFAULT_OPTIONS = {
    selector: "[data-scroll-animate]",
    rootMargin: "0px",
    threshold: 0.2,
};
export function initScrollAnimation(options = {}) {
    const config = { ...DEFAULT_OPTIONS, ...options };
    const elements = document.querySelectorAll(config.selector);
    if (elements.length === 0) {
        return () => { };
    }
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const element = entry.target;
                element.setAttribute("data-visible", "");
                // Remove animation attributes after transition completes to avoid stacking context issues
                const cleanup = () => {
                    element.removeAttribute("data-scroll-animate");
                    element.removeAttribute("data-short-animate");
                };
                // Get transition duration and delay from computed styles
                // Use requestAnimationFrame to ensure styles are applied first
                requestAnimationFrame(() => {
                    const computedStyle = window.getComputedStyle(element);
                    const duration = parseFloat(computedStyle.transitionDuration) * 1000 || 0;
                    const delay = parseFloat(computedStyle.transitionDelay) * 1000 || 0;
                    const totalTime = duration + delay;
                    // Remove attributes after transition completes (add small buffer for safety)
                    setTimeout(cleanup, totalTime + 50);
                });
                observer.unobserve(entry.target);
            }
        });
    }, {
        rootMargin: config.rootMargin,
        threshold: config.threshold,
    });
    elements.forEach((element) => {
        observer.observe(element);
    });
    return () => {
        elements.forEach((element) => {
            observer.unobserve(element);
        });
        observer.disconnect();
    };
}
